var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    attrs: {
                      disabled: _vm.$store.getters["Ajax/loading"],
                      text: "",
                      icon: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.click()
                      }
                    }
                  },
                  on
                ),
                [_c("v-icon", [_vm._v(_vm._s(_vm.actionItem.icon))])],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "components.actionButtons." +
                _vm.actionItem.tooltip.replace(/[."\s]/g, "")
            )
          )
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }